/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_Forgotten_At_LastInputs */

const en_us2_workout_live_forgotten_at_last = /** @type {(inputs: Workout_Live_Forgotten_At_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At the last set`)
};

const pt_br2_workout_live_forgotten_at_last = /** @type {(inputs: Workout_Live_Forgotten_At_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na última série`)
};

const es_419_workout_live_forgotten_at_last = /** @type {(inputs: Workout_Live_Forgotten_At_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En la última serie`)
};

const pt_pt2_workout_live_forgotten_at_last = /** @type {(inputs: Workout_Live_Forgotten_At_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na última série`)
};

const fr_fr2_workout_live_forgotten_at_last = /** @type {(inputs: Workout_Live_Forgotten_At_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À la dernière série`)
};

const de_de2_workout_live_forgotten_at_last = /** @type {(inputs: Workout_Live_Forgotten_At_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim letzten Satz`)
};

const it_it2_workout_live_forgotten_at_last = /** @type {(inputs: Workout_Live_Forgotten_At_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All'ultima serie`)
};

/**
* | output |
* | --- |
* | "At the last set" |
*
* @param {Workout_Live_Forgotten_At_LastInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_forgotten_at_last = /** @type {((inputs?: Workout_Live_Forgotten_At_LastInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Forgotten_At_LastInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_forgotten_at_last(inputs)
	if (locale === "es-419") return es_419_workout_live_forgotten_at_last(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_forgotten_at_last(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_forgotten_at_last(inputs)
	if (locale === "de-DE") return de_de2_workout_live_forgotten_at_last(inputs)
	if (locale === "it-IT") return it_it2_workout_live_forgotten_at_last(inputs)
	return en_us2_workout_live_forgotten_at_last(inputs)
});
export { workout_live_forgotten_at_last as "workout-live.forgotten_at_last" }